exports.connect = {
	url: "https://api.leboisdepins.camp/"
}
